export default "__VITE_ASSET__76fa15f2__"